import { Component, OnInit, Input } from '@angular/core';
import { SPHLoggedInUser, SPHLicense, SPHApplication } from '../../shared/shared';

@Component({
    selector: 'license-attribute-configuration',
    templateUrl: 'license-attribute-configuration.component.html'
})

export class LicenseAttributeConfigurationComponent {
    @Input() public availableApplications: SPHApplication[] = [];

    @Input() public set user(user: SPHLoggedInUser) {
        this._user = user;
    }
    public get user(): SPHLoggedInUser {
        return this._user;
    }
    @Input() public set license(license: SPHLicense) {
        this._license = license;
    }
    public get license(): SPHLicense {
        return this._license;
    }

    private _user: SPHLoggedInUser;
    private _license: SPHLicense;
    private hasExcellentConnectApp() {
        if (this.license.applications.filter( (e) => e.name === 'eproject' ).length > 0) {
            return true;
        } else {
            return false;
        }
    }

    private applicationActive(application: SPHApplication) {
        if (this.license.applications.filter( (element) => element.id === application.id).length > 0) {
                return true;
            } else {
                return false;
            }
    }

    private didTapApp(application: SPHApplication) {
        if (this.user.isUniAdmin) {
            if (this.applicationActive(application)) {
                this.license.applications = this.license.applications.filter( (element) => element.id !== application.id);
            } else {
                this.license.applications.push(application);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/features/companyLicenseManagement/licenseAttributeConfigurationComponent/license-attribute-configuration.component.ts